/**
 * Admin account settings — same password change as 従業員 (EmployeeSettings).
 * Loads the logged-in office user from sessionStorage (管理者 / 現場管理者).
 */

import React, { useEffect, useState } from 'react';
import { EmployeeSettings } from '../../components/EmployeeView/EmployeeSettings';

type StoredEmployee = {
  empCode: string;
  name: string;
  userType: string;
};

export const AdminAccountSettings: React.FC = () => {
  const [employee, setEmployee] = useState<StoredEmployee | null>(null);
  const [loadError, setLoadError] = useState<string | undefined>(undefined);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem('currentEmployee');
      if (!raw) {
        setLoadError('ログイン情報が見つかりません。再度ログインしてください。');
        return;
      }
      const parsed = JSON.parse(raw) as StoredEmployee;
      if (!parsed?.empCode || !parsed?.name) {
        setLoadError('アカウント情報が不完全です。再度ログインしてください。');
        return;
      }
      setEmployee(parsed);
    } catch {
      setLoadError('アカウント情報の読み込みに失敗しました。');
    }
  }, []);

  if (loadError) {
    return (
      <div className="main-content">
        <p style={{ color: '#c0392b' }}>{loadError}</p>
      </div>
    );
  }

  if (!employee) {
    return (
      <div className="main-content" style={{ padding: '24px' }}>
        <p>読み込み中...</p>
      </div>
    );
  }

  return <EmployeeSettings currentEmployee={employee} />;
};
